/**
 * Utility method to do fixed point comparison on floating point numbers
 * @param a
 * @param b
 * @param precision - precision in number of decimals
 * @returns < 0 if a < b, > 0 if a > b, 0 if equal
 */ function fixedPointFloatCompare(a, b, precision) {
    var multiplier = Math.pow(10, precision);
    return Math.floor(a * multiplier) - Math.floor(b * multiplier);
}
export function fixedPointLessThan(a, b, precision) {
    return fixedPointFloatCompare(a, b, precision) < 0;
}
export function fixedPointGreaterThan(a, b, precision) {
    return fixedPointFloatCompare(a, b, precision) > 0;
}
export function fixedPointLessThanEq(a, b, precision) {
    return fixedPointFloatCompare(a, b, precision) <= 0;
}
export function fixedPointGreaterThanEq(a, b, precision) {
    return fixedPointFloatCompare(a, b, precision) >= 0;
}
export function fixedPointEqual(a, b, precision) {
    return fixedPointFloatCompare(a, b, precision) === 0;
}
export function fixedPointInRange(target, start, end, precision, config) {
    var startCompareMethod = (config === null || config === void 0 ? void 0 : config.inclusiveStart) ? fixedPointGreaterThanEq : fixedPointGreaterThan;
    var endCompareMethod = (config === null || config === void 0 ? void 0 : config.inclusiveEnd) ? fixedPointLessThanEq : fixedPointLessThan;
    return startCompareMethod(target, start, precision) && endCompareMethod(target, end, precision);
}

//# sourceMappingURL=float-utils.js.map